// extracted by mini-css-extract-plugin
module.exports = {"activityTab":"activity_activityTab__Jw8RU","form":"activity_form__1pDFy"};